export default {
    mainColors: ["Burgundy", "White", "Black"],
    iconName: "burgundy.svg",
    colors: [
        "rgba(190,39,69,1)",
        "rgba(0,0,0,1)",
        "rgba(0,0,0,1)",
        "rgba(255,255,255,1)",
        "rgba(190,39,69,1)",
        "rgba(205,107,127,1)",
        "rgba(255,255,255,1)",
        "rgba(255,255,255,1)",
        "rgba(255,255,255,1)",
        "rgba(255,255,255,1)",
        "rgba(255,255,255,1)",
        "rgba(255,255,255,1)"
    ],
    themeSettings: {
        "fontFamily":              "Inter",
        "cartIconStyle":   "shopping-cart",
        "spinnerIconStyle": "spinner-third",
        "iconStyle":               "regular",
        "bgColor":                "#FFFFFF",
        "bgColorFont":            "#767676",
        "primaryColor":           "#934346",
        "primaryColorFont":       "#2E2E2E",
        "secondaryColor":         "#934346",
        "secondaryColorFont":     "#4A4A4A",
        "lightestColor":          "#FFFFFF",
        "lightestColorFont":      "#FFFFFF",
        "lighterColor":           "#E3B8BA",
        "lighterColorFont":       "#E3B8BA",
        "middleColor":            "#5D1D1F",
        "middleColorFont":        "#5D1D1F",

        "iconColors":                 "#934346",
        "iconColorsHover":            "#7C3033",
        "lightBorderColor":           "#DDDDDD",
        "menuBackgroundColor":        "#FFFFFF",
        "menuBorderColor":            "#E7E7E7",
        "menuIconsAndFontColor":      "#2E2E2E",
        "menuIconsAndFontColorHover": "#7C3033",
        "inputsBgColor":              "#FFFFFF",
        "inputsBorderColor":          "#4A4A4A",
        "inputsHoverColor":           "#7C3033",
        "formsBgColor":               "#FBFBFB",
        "footerColorBackground":      "#934346",
        "footerColorFont":            "#F1DDDE",
        "footerColorLinks":           "#F8F9FA",
        "footerBannerBackground":     "#FFFFFF",
        "btnSolidBgColor":            "#934346",
        "btnSolidTextColor":          "#FFFFFF",
        "hoverOverButton":            "#7C3033",
        "btnSolidHoverTextColor":     "#FFFFFF",

        "secondaryBtnBgColor":      "#FFFFFF",
		"secondaryBtnFontColor":    "#934346",
		"secondaryBtnBorderColor":  "#934346",
		"secondaryBtnHoverBgColor": "#FFFFFF",
		"secondaryBtnHoverFontColor":   "#7C3033",
		"secondaryBtnHoverBorderColor": "#7C3033",
        "fontColorGreyBar":         "#717171",
        "iconColorGreyBar":         "#717171",
        "colorBackgroundLogo":      "#FFFFFF",
        "focusVisibleColor":        "#FF00D9",

        "newsletterBgColor":                        "#F3F3F3",
        "newsletterFont":                           "#2E2E2E",
        "headerIconsAndFontColor":                  "#232323",
        "headerIconsAndFontColorHover":             "#934346",
        "headerCounterBgColor":                     "#934346",
        "headerCounterBgColorHover":                "#934346",
        "headerCounterFontColor":                   "#FFFFFF",
        "headerCounterFontColorHover":              "#FFFFFF",
        "headerCartIconAndFontColor":               "#232323",
        "headerCartIconAndFontColorHover":          "#934346",
        "topBannerBgColor":                         "#934346",
        "topBannerFontColor":                       "#FFFFFF",
        "topBannerFontHoverColor":                  "#FFFFFF",
        "textElementBg": "#F3F3F3",
        "textElementFont": "#232323",

        "ribbonTextColor":              "#FFFFFF",
        "ribbonPromotion":              "#DA2442",
        "ribbonBestRated":              "#855FC6",
        "ribbonNewProduct":             "#253A75",
        "ribbonRecommendedProduct":     "#008945",
        "filterIcons":                  "#2E2E2E",
        "ribbonPromotionalProduct":     "#767676",
        "ribbonVendorRecomendation":    "#1B6FB1",
        "ribbonGreatPrice":             "#976351",
        "ribbonGreatQuality":           "#66E7DB",
        "ribbonSale":                   "#F5A623",
        "ribbonReward":                 "#FA7719",

        "alertsTextColor":      "#232323",
        "errorColor":           "#DA2442",
        "warningColor":         "#F5A623",
        "warningColorHover":    "#F57C00",
        "successColor":         "#008945",
        "infoColor":            "#F8F8F8",
        
        "bannerFontColor":              "#232323",
        "bannerSecondaryFontColor":     "#232323",
        "bannerBtnBgColor":             "#934346",
        "bannerBtnFontColor":           "#FFFFFF",
        "bannerBtnHoverBgColor":        "#7C3033",
        "bannerBtnHoverFontColor":      "#FFFFFF",
        "bannerPromotionalFontColor":    "#FFFFFF",
        "bannerTimerBgColor":          "rgba(255, 255, 255, 0)",
        "bannerTimerBorderColor":      "#934346",
        "bannerTimerFontColor":        "#FFFFFF",
        "bannerTimerNumbersColor":      "#FFFFFF",
        "bannerTextFieldColor":         "#F3F3F3",
        "activeListIconBackgroundColor":"#f8f9fa",
        "activeListIconColor":          "#2e2e2e",
        "inactiveListIconColor":        "#959595"
    }
}